<script>
import store from '../state/store'
export default {
  props: ["MenuData"],
  data() {
    return {
      AuthKontrol:null
    };
  },

  methods: {},
  created(){
    this.AuthKontrol = store.getters.['auth/isAuth']
  },
  name: "menucomponent",
}; 
</script>
 
<template> 


 <div class="dropdown-list-menu"> 
                                    <ul class="menu-item">
                                        <li v-for="(Data,index) in MenuData" :key="index">
                                          <a v-if="!Data.Auth && AuthKontrol" :href="Data.Link">{{ Data.Title }}</a>
                                          
                               <menucomponent :MenuData="Data.Children" v-if="Data.Children"/>
                                          </li> 
                                    </ul>
                                </div>

  
</template>
